/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils\customAppDefaults.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/


export function getDefaultScript(type: 'lua' | 'xml'): string {
    if (type === 'lua') {
        return `-- Custom Application
-- Variables available: CUSTOM_APP_DOMAIN, CUSTOM_APP_UUID, caller_id_number

-- Answer the call
session:answer()
session:sleep(500)

-- Your logic here
session:streamFile("ivr/ivr-welcome.wav")

-- Set result: "continue" (go to final dest), "hangup", or "transfer:1000"
session:setVariable("APP_RESULT", "continue")
`;
    } else {
        return `<!-- Custom XML Application -->
<extension name="custom_app">
  <condition>
    <action application="answer"/>
    <action application="sleep" data="500"/>
    <action application="playback" data="ivr/ivr-welcome.wav"/>
    <action application="set" data="APP_RESULT=continue"/>
  </condition>
</extension>
`;
    }
}
